import React from 'react';
import DimensionItem from '../../../overrides/venia-ui/components/ProductFullDetail/Specifications/DimensionItem';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './tearsheetPDF.module.css';

var BulbRecommendation = function BulbRecommendation(props) {
  var _product$custom_attri2;

  var product = props.product,
      isPDF = props.isPDF;
  var bulbRecommendationAttributes = ['hf_item_number', 'hf_manufacturer', 'hf_base', 'hf_wattage', 'hf_type_or_shape', 'hf_color_temp', 'hf_qty_per_product', 'hf_included', 'hf_bulb2item_number', 'hf_bulb2manufacturer', 'hf_bulb2base', 'hf_bulb2wattage', 'hf_bulb2type_or_shape', 'hf_bulb2color_temp', 'hf_bulb2qty_per_product', 'hf_bulb2included'];
  var classes = useStyle(defaultClasses, props.classes);

  var _product$custom_attri = product === null || product === void 0 ? void 0 : (_product$custom_attri2 = product.custom_attributes) === null || _product$custom_attri2 === void 0 ? void 0 : _product$custom_attri2.reduce(function (acc, attribute) {
    var _attribute$attribute_, _attribute$attribute_2;

    var code = attribute === null || attribute === void 0 ? void 0 : (_attribute$attribute_ = attribute.attribute_metadata) === null || _attribute$attribute_ === void 0 ? void 0 : _attribute$attribute_.code;
    var label = attribute === null || attribute === void 0 ? void 0 : (_attribute$attribute_2 = attribute.attribute_metadata) === null || _attribute$attribute_2 === void 0 ? void 0 : _attribute$attribute_2.label;

    if (code !== null && code !== void 0 && code.startsWith('hf_bulb2')) {
      acc.recommendedBulb2.push({
        label: label.replace(/Bulb\s*\d+/g, ''),
        value: product === null || product === void 0 ? void 0 : product[code],
        constructed_value: true
      });
    } else if (bulbRecommendationAttributes.includes(code)) {
      acc.recommendedBulb.push({
        label: label.replace(/Bulb\s*\d+/g, ''),
        value: product === null || product === void 0 ? void 0 : product[code],
        constructed_value: true
      });
    }

    return acc;
  }, {
    recommendedBulb: [],
    recommendedBulb2: []
  }),
      recommendedBulb = _product$custom_attri.recommendedBulb,
      recommendedBulb2 = _product$custom_attri.recommendedBulb2;

  return React.createElement("div", {
    className: "".concat(isPDF ? 'flex justify-end' : '', " ")
  }, recommendedBulb !== null && recommendedBulb !== void 0 && recommendedBulb.length ? React.createElement("div", {
    className: classes.recommendation
  }, React.createElement("p", {
    className: "font-bold  mt-4 bg-snowbound"
  }, "Recommended Bulb 1"), recommendedBulb === null || recommendedBulb === void 0 ? void 0 : recommendedBulb.map(function (specValue, idx) {
    return React.createElement(DimensionItem, {
      key: idx,
      measure: specValue.label,
      value: specValue.value,
      isPdf: isPDF
    });
  })) : null, recommendedBulb2 !== null && recommendedBulb2 !== void 0 && recommendedBulb2.length ? React.createElement("div", {
    className: classes.recommendation
  }, React.createElement("p", {
    className: "font-bold  mt-4 bg-snowbound"
  }, "Recommended Bulb 2"), recommendedBulb2 === null || recommendedBulb2 === void 0 ? void 0 : recommendedBulb2.map(function (specValue, idx) {
    return React.createElement(DimensionItem, {
      key: idx,
      measure: specValue.label,
      value: specValue.value,
      isPdf: isPDF
    });
  })) : null);
};

export default BulbRecommendation;